module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAALVBMVEUAAAAt1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t3CSZN+AAAADnRSTlMADscG2s9rU/Xz1RtvUZlNtPIAAABKSURBVBjTY8APzDQnJcPY3HHv3j3dAOWYPikU91sM5eQ5MjBIvYFy9AoYGHgfQTl9AgwMjC+gnHcQCpPzDgrQOAhVtOTgcQEeAADRljsGMzM/yAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lock-hover.png
// module id = 450
// module chunks = 0 1 2 3 4 5 6 7